import React from 'react';

function StatCard({ icon, label, value, color, bgColor }) {
  return (
    <div className="card stat-card shadow-sm h-100">
      <div className="card-body d-flex align-items-center gap-3">
        <div className="stat-icon" style={{ background: bgColor || '#e7f1ff', color: color || '#0d6efd' }}>
          <i className={`bi ${icon}`}></i>
        </div>
        <div>
          <div className="stat-value" style={{ color: color || '#212529' }}>{value}</div>
          <div className="stat-label">{label}</div>
        </div>
      </div>
    </div>
  );
}

export default StatCard;
